<text-loader [run]="loading" [text]="'Loading Notes'" [tickType]="'.'" [interval]="1000"></text-loader>
<table>
    <caption>Clarification Notes</caption>
  <tr>
    <th style="width: 10%">&nbsp;</th>
    <th style="width: 60%;">&nbsp;</th>
    <th style="width: 30%;">&nbsp;</th>
  </tr>
  @for (page of notes; track page) {
    @for (view of page.views; track view) {
      <tr>
        <td colspan="3">
          <span class="bold padding-right">Section:</span>{{ page.sectionTitle }}
          <span class="bold padding-left padding-right">Page:</span>{{page.pageTitle}}
        </td>
      </tr>
      <tr>
        <td class="bold top-align">Question:</td>
        <td [innerHTML]="view.label"></td>
        <td class="top-align"><span class="bold">Response:</span> {{view.value}}</td>
      </tr>
      @for (note of view.notes; track note) {
        <tr>
          <td class="padding-bottom" colspan="3">
            <table>
              <caption>Clarification Note</caption>
              <tr class="note-header default-font clarification-note ">
                <th class="text-align-left padding-all">Created by {{note.createdBy}}</th>
                <th class="text-align-right padding-all">on {{note.createdDate | date: 'M/d/yy | h:mma'}}</th>
              </tr>
              <tr class="clarification-note">
                <td colspan="2" class="padding-all" [innerHTML]="note.text">
                </td>
              </tr>
              @for (childNote of note.notes; track childNote) {
                <tr>
                  <td colspan="2">
                    <table>
                      <caption>Clarification Note Reply</caption>
                      <tr class="note-header default-font clarification-note">
                        <th class="text-align-left padding-all">Replied to by {{childNote.createdBy}}</th>
                        <th class="text-align-right padding-all">on {{childNote.createdDate | date: 'M/d/yy | h:mma'}}</th>
                      </tr>
                      <tr class="clarification-note">
                        <td colspan="2" class="padding-all" [innerHTML]="childNote.text">
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              }
            </table>
          </td>
        </tr>
      }
    }
  }
</table>
